
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from 'react';
import { GetServerSidePropsContext, GetServerSidePropsResult, NextPage } from 'next';
import useTranslation from 'next-translate/useTranslation';
import styles from './index.module.scss';
import Layout from 'components/Layout';
import { Namespace } from 'enums/namespaces';
import classNames from 'classnames';
import { withForcePlanToLoggedInUnsubs } from 'context';
import Head from 'next/head';
import { basicSEO, createRedirectIfNeeded } from 'helpers';
import Trans from 'next-translate/Trans';
import { StaticPathParams } from 'typings/staticPaths';
import { authorizeUserServerSide } from 'api/firebaseAdmin';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface Props {
  countryCode: string;
}

const Samsung: NextPage<Props> = ({ countryCode }) => {
  const { t } = useTranslation(Namespace.VideoStreaming);

  return (
    <Layout countryCode={countryCode}>
      <Head>
        {basicSEO(t('seo:how_to_watch_streaming_airplay_title'), t('seo:how_to_watch_streaming_airplay_description'))}
      </Head>
      <main className={[styles.container].join(' ')}>
        <h1>{t('airplay_title')}</h1>
        <p className={styles.desc} dangerouslySetInnerHTML={{ __html: t('airplay_description') }}></p>
        <h2>{t('airplay_instalation')}</h2>
        <ol>
          <li>
            <p dangerouslySetInnerHTML={{ __html: t('airplay_step_1') }}></p>
          </li>
          <li>
            <p dangerouslySetInnerHTML={{ __html: t('airplay_step_2') }}></p>
          </li>
          <li>
            <p dangerouslySetInnerHTML={{ __html: t('airplay_step_3') }}></p>
          </li>
          <li>
            <p>
              <Trans i18nKey={'video-streaming:airplay_step_4'} components={[<span className={styles.airplay} />]} />
            </p>
            <div className={classNames(styles.img, styles['step-4'])} />
          </li>
          <li>
            <p dangerouslySetInnerHTML={{ __html: t('airplay_step_5') }}></p>
          </li>
        </ol>
      </main>
    </Layout>
  );
};

 async function _getServerSideProps(
  ctx: GetServerSidePropsContext<StaticPathParams>,
): Promise<GetServerSidePropsResult<Props>> {
  const { locale, apiClient, countryCode } = await authorizeUserServerSide(ctx);

  const redirect = createRedirectIfNeeded(ctx, locale);
  if (redirect) {
    return redirect;
  }

  return {
    props: { countryCode },
  };
}

export default withForcePlanToLoggedInUnsubs(Samsung);


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/how-to-watch/video-streaming/apple-airplay/index',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  